<script>
    import { authFackMethods, notificationMethods } from "@/state/helpers";
    import { mapState } from "vuex";

    import appConfig from "@/app.config";
    import { required } from "vuelidate/lib/validators";

    /**
     * Login-2 component
     */
    export default {
        page: {
            title: "Connexion",
            meta: [
                {
                    name: "description",
                    content: appConfig.description
                }
            ]
        },
        data() {
            return {
                email: null,
                password: null,
                submitted: false,
                authError: null,
                tryingToLogIn: false,
                isAuthError: false,
                loading: false
            };
        },
        validations: {
            email: {
                required
            },
            password: {
                required
            }
        },
        computed: {
            ...mapState("authfack", ["status"]),
            notification() {
                return this.$store ? this.$store.state.notification : null;
            }
        },
        methods: {
            ...authFackMethods,
            ...notificationMethods,
            // Try to log the user in with the username
            // and password they provided.
            async tryToLogIn() {
                this.submitted = true;
                // stop here if form is invalid
                this.$v.$touch();

                if (this.$v.$invalid) {
                    return;
                } else {
                    const { email, password } = this;
                    if (email && password) {
                        this.loading = true;
                        await this.login({
                            email,
                            password
                        });
                        this.loading = false;
                    }
                }
            }
        }
    };
</script>

<template>
    <div>
        <div class="container-fluid p-0">
            <div>
                <div
                    class="auth-full-page-content d-flex flex-column align-items-center justify-content-center"
                    :style="{ background: 'url(' + require('@/assets/images/students.jpeg') + ') no-repeat center', backgroundSize: 'cover' }"
                >
                    <router-link to="/" class="d-block auth-logo">
                        <img src="@/assets/images/ofppt-logo.png" alt="" height="100" class="auth-logo-dark" />
                        <img src="@/assets/images/logo-light.png" alt="" height="18" class="auth-logo-light" />
                    </router-link>
                    <div class="card">
                        <div class="d-flex flex-column">
                            <div class="my-auto">
                                <div class="text-center">
                                    <h5 class="text-primary">Bienvenue à nouveau !</h5>
                                    <p class="text-muted">Connectez-vous pour continuer</p>
                                </div>

                                <div class="mt-4">
                                    <form @submit.prevent="tryToLogIn">
                                        <div class="form-group">
                                            <label for="username">Matricule</label>
                                            <b-form-input
                                                id="username"
                                                v-model="email"
                                                type="text"
                                                placeholder="Votre matricule"
                                                :class="{ 'is-invalid': submitted && $v.email.$error }"
                                            ></b-form-input>
                                            <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                                                <span v-if="!$v.email.required">Veuillez saisir votre matricule</span>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <!-- <div class="float-right">
                                                    <router-link to="/auth/recoverpwd-2" class="text-muted">Forgot password?</router-link>
                                                </div> -->
                                            <label for="userpassword">Mot de passe</label>
                                            <b-form-input
                                                id="userpassword"
                                                v-model="password"
                                                type="password"
                                                placeholder="Votre mot de passe"
                                                :class="{ 'is-invalid': submitted && $v.password.$error }"
                                            ></b-form-input>
                                            <div v-if="submitted && !$v.password.required" class="invalid-feedback">
                                                Veuillez saisir votre mot de passe
                                            </div>
                                        </div>

                                        <!-- <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" id="auth-remember-check" />
                                                <label class="custom-control-label" for="auth-remember-check">Remember me</label>
                                            </div> -->

                                        <div class="mt-3">
                                            <q-button type="submit" variant="primary" block :loading="loading">Se connecter</q-button>
                                        </div>

                                        <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{ authError }}</b-alert>
                                        <div v-if="notification.message" :class="'mt-3 mb-0 text-center font-size-13 alert ' + notification.type">
                                            {{ notification.message }}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end row -->
        </div>
        <!-- end container-fluid -->
    </div>
</template>
